// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3MwYE","list":"PatternAutocomplete_list__2R3r8"};